// extracted by mini-css-extract-plugin
export default {"subhead":"style_subhead__hNzdo"};